module.exports = __webpack_public_path__ + "img/machine _translation.583a3c3e.png";